import React from "react";
import clsx from "clsx";

type UICMSContentProps = {
	content: string;
	editable?: boolean;
	onInput?: (e: React.FormEvent<HTMLElement>) => any;
	cmsField?: string;
	className?: string;
};

export const UICMSContent: React.FC<UICMSContentProps> = (props: UICMSContentProps) => {
	const value = (props.content || "").replace(/(\r\n|\n|\r)/gm, "");
	if (!value || value === "<p></p>" || value === "<p><br></p>") return null;
	return (
		<div
			className={clsx("cms-content", props.editable && "cms-editable-field", props.className)}
			contentEditable={props.editable}
			dangerouslySetInnerHTML={{ __html: props.content }}
			data-cms-field={props.cmsField}
			data-cms-allow-html={true}
			// onInput={props.onInput}
			onBlur={props.onInput}
		/>
	);
};
